import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { LazyLoadEvent, SelectItemGroup } from 'primeng/api/public_api';
import { Table } from 'primeng/table';
import { SimuladorService } from 'src/app/datos/simulador.service';
import { FormValidation } from 'src/app/libs/ruvpp-angular2-comun/FormValidation';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { DatosElementoDTO, ElementosDTO, ElementosForm, InputObtenerElementos_Pages, OutputObtenerElementos_Pages, InputObtenerPrototipo_Pages, OutputObtenerPrototipo_Pages, PrototipoForm, PrototipoDTO, InputActualizarEstatusPrototipo, InputObtenerEspacio_Pages, OutputObtenerEspacio_Pages, EspacioDTO, InputObtenerPrototipoDetalle, OutputObtenerPrototipoDetalle, InputAgregarPrototipo, InputActualizarEstatusDocumento, DocumentoDTO } from 'src/app/modelo';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-catalogo-prototipos',
    templateUrl: './catalogo-prototipos.component.html',
    //styleUrls: ['../../../assets/css/styles.css', '../../../assets/css/bootstrap.css']
})
export class CatalogoPrototiposComponent implements OnInit {

    public datosElementoDTO: DatosElementoDTO;
    public modalTitulo: string;
    public modal: boolean = false;

    @ViewChild('tabla') tabla: Table;
    public isLoading: boolean;
    public prototipoDTO: OutputObtenerPrototipo_Pages;
    public filtro: PrototipoForm;
    public entidad: PrototipoForm;
    public grupoEspacios: SelectItemGroup[];
    public listEspacios: EspacioDTO[];
    public idEspacio: number;
    public entity: PrototipoDTO;

    @ViewChild('fileUpload') fileUpload: any;
    public uploadedFiles: any[] = [];
    public msgs: Message[] = [];
    public progressSpinner: boolean;


    //Validaciones

    public ListaEspacios_MensajeError: FormValidation = new FormValidation(null);
    public NombrePrototipo_MensajeError: FormValidation = new FormValidation(null);
    public TipoPrototipo_MensajeError: FormValidation = new FormValidation(null);


    //Menu

    public menu: MenuComponent;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    /**
     * 
     */
    ngOnInit() {
        this.init();
        this.loading();
    }

    /**
    * 
    */
    private init(): void {
        this.filtro = <PrototipoForm>{};
        this.prototipoDTO = <OutputObtenerPrototipo_Pages>{ listPrototipo: [], totalRecords: 0 };
        this.entidad = <PrototipoForm>{ listEspacioSelect: [], nombrePrototipo: null };
        this.initValidacion();
    }

    /**
     * 
     */
    private initValidacion(): void {
        this.ListaEspacios_MensajeError = new FormValidation(null);
        this.NombrePrototipo_MensajeError = new FormValidation(null);
        this.TipoPrototipo_MensajeError = new FormValidation(null);
    }

    /**
     * 
     */
    private async loading() {

        //Tipo de prototipo
        {
            this.filtro.listTipoPrototipo = [];

            let resultado: JsonResponse<DatosElementoDTO> = await this.service.ObtenerElementos().toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {
                this.datosElementoDTO = resultado.model;
                this.setFilter(this.datosElementoDTO, this.filtro);
            }

        }

        //Espacios

        {
            this.listEspacios = [];

            let data: InputObtenerEspacio_Pages = <InputObtenerEspacio_Pages>{ pagina: 1, tamanioPagina: 9000 };

            let resultado: JsonResponse<OutputObtenerEspacio_Pages> = await this.service.ObtenerEspacioPages(data).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {
                this.listEspacios = resultado.model.listEspacios
            }

        }

        //Agrupar Espacios
        {
            this.grupoEspacios = [];

            for (let tipoEspacio of this.datosElementoDTO.listTipoEspacio) {

                let filter = this.listEspacios.filter(row => row.idTipoEspacio == tipoEspacio.idTipoEspacio);

                let items: any = [];

                if (filter != null) {

                    for (let row of filter) {
                        items.push({ label: row.nombreEspacio, value: row.idEspacio });
                    }
                }

                let dato: any = {
                    label: tipoEspacio.nombreTipoEspacio,
                    items: items
                };

                this.grupoEspacios.push(dato);
            }

        }

    }


    /**
     * 
     */
    public addEspacio(): void {

        let filter = this.listEspacios.filter(row => row.idEspacio == this.idEspacio);

        if (filter != null && filter.length > 0) {

            let espacioDTO: EspacioDTO = filter[0];

            this.entidad.listEspacioSelect.push(espacioDTO);

            this.actualizarErrores('ListaEspacios');
        }

    }

    /**
     * 
     * @param entity
     */
    public deleteEspacio(entity: EspacioDTO): void {

        const index = this.entidad.listEspacioSelect.findIndex(row => row == entity);

        this.entidad.listEspacioSelect.splice(index, 1);

    }


    /**
     * 
     */
    public nuevoRegistro(): void {

        this.initValidacion();

        this.idEspacio = 0;

        this.entidad = <PrototipoForm>{ idPrototipo: null, listEspacioSelect: [], nombrePrototipo: null, typeView: 'add' };

        this.setFilter(this.datosElementoDTO, this.entidad);

        this.modalTitulo = 'Agregar';

        this.showModalEditar();
    }

    /**
     * 
     * @param entity
     */
    public async editar(entity: PrototipoDTO) {

        this.initValidacion();

        this.entidad = <PrototipoForm>{ idPrototipo: entity.idPrototipo, nombrePrototipo: entity.nombrePrototipo, listEspacioSelect: [], listDocumento: [], tipoPrototipo: entity.idTipoPrototipo, typeView: 'edit' };

        this.setFilter(this.datosElementoDTO, this.entidad);

        this.modalTitulo = 'Editar registro';

        this.entity = entity;

        await this.ObtenerPrototipoDetalle(this.entidad.idPrototipo);

        this.showModalEditar();
    }

    /**
     * 
     * @param idPrototipo
     */
    private async ObtenerPrototipoDetalle(idPrototipo: number) {

        let data: InputObtenerPrototipoDetalle = <InputObtenerPrototipoDetalle>{ idPrototipo: idPrototipo };

        let resultado: JsonResponse<OutputObtenerPrototipoDetalle> = await this.service.ObtenerPrototipoDetalle(data).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            let detalle: OutputObtenerPrototipoDetalle = resultado.model;

            if (detalle != null && detalle.listEspacioxPrototipo != null) {

                for (let row of detalle.listEspacioxPrototipo) {

                    let espacioDTO: EspacioDTO = <EspacioDTO>{ idEspacio: row.idEspacio, nombreEspacio: row.nombreEspacio };

                    this.entidad.listEspacioSelect.push(espacioDTO);
                }

            }

            this.entidad.listDocumento = detalle.listDocumento;

        }
    }

    /**
     * 
     * @param entity
     */
    public deleteDocumento(entity: DocumentoDTO): void {

        let dato: InputActualizarEstatusDocumento = <InputActualizarEstatusDocumento>{ idDocumento: entity.idDocumento, documentoActivo: false };

        this.service.ActualizarEstatusDocumento(dato).subscribe(resultado => {

            this.ObtenerPrototipoDetalle(this.entity.idPrototipo);

        });

        //this.servicioAlertas.mostrarConOpciones({
        //    title: "Simulador",
        //    text: `Está seguro de eliminar el documento`,
        //    icon: "question",
        //    showCancelButton: true,
        //    confirmButtonColor: '#3085d6',
        //    cancelButtonColor: '#d33',
        //    confirmButtonText: 'Si',
        //    cancelButtonText: 'No'
        //}).then((result) => {

        //    if (result.value) {

        //        let dato: InputActualizarEstatusDocumento = <InputActualizarEstatusDocumento>{ idDocumento: entity.idDocumento, documentoActivo: false };

        //        this.service.ActualizarEstatusDocumento(dato).subscribe(resultado => {

        //            this.ObtenerPrototipoDetalle(this.entity.idPrototipo);

        //        });

        //    }

        //})

    }

    /**
     * 
     * @param event
     * @param fileUpload
     */
    public async onFileUpload(event: { files: File }, fileUpload) {

        this.progressSpinner = true;

        var excelParametros = { idPrototipo: this.entity.idPrototipo };

        let respuesta: JsonResponse<string> = await this.service.AgregarDocumento(event, excelParametros).toPromise();

        if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {

            this.fileUpload.clear();

            this.ObtenerPrototipoDetalle(this.entity.idPrototipo);

            this.progressSpinner = false;

            this.msgs = [];

            this.msgs.push({ severity: 'success', summary: 'Archivo(s) subido(s) ...', detail: '' });

            setTimeout(() => {
                this.msgs = [];
            }, 4000);

        }

    }

    /**
     * 
     */
    public guardar(): void {

        if (!this.validarFormumlario()) {

            let idEspacios: number[] = [];

            for (let row of this.entidad.listEspacioSelect) {
                idEspacios.push(row.idEspacio);
            }

            let dato: InputAgregarPrototipo = <InputAgregarPrototipo>{ idPrototipo: this.entidad.idPrototipo, nombrePrototipo: this.entidad.nombrePrototipo, idEspacios: idEspacios, idTipoPrototipo: this.entidad.tipoPrototipo };

            this.service.AgregarPrototipo(dato).subscribe((resultado: JsonResponse<number>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {

                    this.closeModal();

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador RUV",
                        text: `El registro se guardó con éxito.`,
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                        console.log('result.value -->> ', result.value)

                        if (result.value) {
                            console.log('true')

                            this.Filtrar();

                        } else {

                            if (result.dismiss === Swal.DismissReason.cancel) {
                                console.log('false')
                            }
                        }

                    })

                }
            });

        }
    }

    /**
    * 
    * @param tipo
    */
    public actualizarErrores(tipo: string) {

        switch (tipo) {

            case 'ListaEspacios':

                this.ListaEspacios_MensajeError = new FormValidation(null);

                if (this.entidad.listEspacioSelect.length == 0) {
                    this.ListaEspacios_MensajeError.requered('Debe de ingresar al menos un espacio en la lista');
                }

                break;

            case 'NombrePrototipo':
                this.NombrePrototipo_MensajeError = new FormValidation(this.entidad.nombrePrototipo).requered('El nombre del prototipo es obligatorio.');
                break;

            case 'TipoPrototipo':
                this.TipoPrototipo_MensajeError = new FormValidation(this.entidad.tipoPrototipo).requered('El tipo prototipo es obligatorio.');
                break;
        }

    }

    /**
     * 
     */
    public validarFormumlario(): boolean {

        var error = false;

        if (this.entidad.listEspacioSelect.length == 0) {
            this.ListaEspacios_MensajeError.requered('Debe de ingresar al menos un espacio en la lista');
        }

        if (this.ListaEspacios_MensajeError.error) {
            error = true;
        }

        this.NombrePrototipo_MensajeError = new FormValidation(this.entidad.nombrePrototipo).requered('El nombre del prototipo es obligatorio.');

        if (this.NombrePrototipo_MensajeError.error) {
            error = true;
        }

        this.TipoPrototipo_MensajeError = new FormValidation(this.entidad.tipoPrototipo).requered('El tipo prototipo es obligatorio.');

        if (this.TipoPrototipo_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     */
    public closeModal(): void {
        this.modal = false;
    }

    /**
     * 
     */
    public showModalEditar(): void {
        this.modal = true;
    }

    /**
     * 
     * @param entity
     * @param form
     */
    private setFilter(entity: DatosElementoDTO, form: PrototipoForm): void {
        form.listTipoPrototipo = entity.listTipoPrototipo;
    }

    /**
     * 
     */
    public Limpiar(): void {
        this.init();
        this.setFilter(this.datosElementoDTO, this.filtro);
        this.Filtrar();
        this.tabla._rows = 10;
    }

    /**
     * 
     */
    public Filtrar(): void {
        this.loadCarsLazy(null);
    }

    /**
     * 
     * @param event
     */
    public loadCarsLazy(event: LazyLoadEvent) {

        this.isLoading = true;

        //in a real application, make a remote request to load data using state metadata from event
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort with
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
        //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

        //imitate db connection over a network

        console.log('event -->> ', event);

        let page: number = 1;
        let tamanioPagina = 10;

        if (event != null && event.first != null) {
            page = (event.first + event.rows) / event.rows;
            tamanioPagina = event.rows;
        }

        let dato: InputObtenerPrototipo_Pages = <InputObtenerPrototipo_Pages>{
            tamanioPagina: tamanioPagina,
            pagina: page,
            idTipoPrototipo: this.filtro.tipoPrototipo,
            nombrePrototipo: this.filtro.nombrePrototipo
        };

        setTimeout(() => {

            this.service.ObtenerPrototipoPages(dato).subscribe((resultado: JsonResponse<OutputObtenerPrototipo_Pages>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {
                    this.prototipoDTO = resultado.model;
                }

                this.isLoading = false;
            });

        }, 1000);
    }

    /**
     * 
     * @param entity
     */
    public onChangePublicar(entity: PrototipoDTO): void {

        if (entity.activo == false) {
            entity.activo = null;
        }

        let dato: InputActualizarEstatusPrototipo = <InputActualizarEstatusPrototipo>{ idPrototipos: [entity.idPrototipo], activo: entity.activo };

        this.service.ActualizarEstatusPrototipo(dato).subscribe(resultado => {

        });

    }

    /**
     * 
     * @param entity
     */
    public delete(entity: PrototipoDTO): void {

        this.servicioAlertas.mostrarConOpciones({
            title: "Simulador",
            text: `Está seguro de eliminar el prototipo [ ${entity.nombrePrototipo} ]`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {

            if (result.value) {

                let dato: InputActualizarEstatusPrototipo = <InputActualizarEstatusPrototipo>{ idPrototipos: [entity.idPrototipo], activo: false };

                this.service.ActualizarEstatusPrototipo(dato).subscribe(resultado => {
                    this.Filtrar();
                });

            }

        })

    }

}